import React, { Fragment } from 'react';
import AbstractComponent from '../AbstractComponent';
import InputCnpj from '../layout/input/InputCnpj';

import ClienteService from '../../service/ClienteService';

import {validarCNPJ} from '../../helper/Validar';

class EmpresaValidarCnpj extends AbstractComponent {  
    constructor(props) {
        super(props);

        this.state = {            
            btnName: 'VERIFICAR CNPJ',

            form: {
                id: 0,
                cnpj: ''
            },

            erroForm: {
                cnpj: ''
            }
        }

        if(props.cnpj !== undefined)
            this.state.form.cnpj = props.cnpj;
    }   

    limpaVariavelErroForm() {
        let erro = this.state.erroForm;

        erro.cnpj = "";        

        this.setState({erroForm: erro});
    }    

    verificarCNPJ(e) {
        this.limpaVariavelErroForm();
                
        let form = this.state.form;                

        if(!form.cnpj) {
            let erro = this.state.erroForm;

            erro.cnpj = "Informe um CNPJ válido";

            this.setState({erroForm: erro});

            this.foco('cnpj');

            return ;        
        }

        if(!validarCNPJ(form.cnpj)) {
            let erro = this.state.erroForm;

            erro.cnpj = "CNPJ inválido";

            this.setState({erroForm: erro});

            this.foco('cnpj');

            return ;        
        }
    
        e.preventDefault();                                                	                        
                                
        this.setState({btnName: 'AGUARDE...'});                

        ClienteService.verificarCNPJ(
            this.state.form.cnpj
        ).then(resposta => {                                   
            let form = this.state.form;                                        

            form.id = resposta.data.id;                        

            this.setState({                    
                passo: 2,
                form: form
            });     
            
            if(this.props.login !== undefined)
                this.props.login(
                    this.state.form.id,
                    this.state.form.cnpj
                );
        }).catch(erro => {   
            if(!erro.data) {
                if(this.props.register !== undefined)
                    this.props.register(this.state.form.cnpj);
            }                
        });
    }

    onChange(e) {          
        const form = this.state.form;        
        form[e.target.name] = e.target.value;
        this.setState({form: form});
    }

    onKeyPress(e) {               
        if (e.key === "Enter") {
            this.verificarCNPJ(e);
        }        
    } 

    show() {        
        if(!this.props.visible)
            return ;

        return (
            <Fragment>
                <div>
                    <div className="row" />
                    <div className="row" />

                    <div className="row">                                            
                        <InputCnpj
                            md={12}
                            xs={12}
                            sm={12}
                            lg={12}
                            id="cnpj"
                            nome="cnpj"                             
                            classNameInput="background-transparent"                              
                            value={this.state.form.cnpj}
                            defaultFoco={true}   
                            defaultValue={this.state.form.cnpj}
                            erro={this.state.erroForm.cnpj}
                            onChange={e => this.onChange(e)}
                            onKeyPress={e => this.onKeyPress(e)}/>                                                                   
                    </div>                                                                                                                                                                                                                                                   
                </div>                                            

                <div className="form-group mt-4 mb-0">
                    <button 
                        type="button"
                        className="btn btn-primary btn-block" 
                        onClick={e => this.verificarCNPJ(e)}
                        disabled={this.state.btnName !== 'VERIFICAR CNPJ'}
                    >
                        {this.state.btnName}
                    </button>
                </div>
            </Fragment>
        );
    }        
    
    render() {
        return(      
            <Fragment>
                { this.show() }                                            
            </Fragment>      
        )
    }
}

export default EmpresaValidarCnpj;